<template>
  <b-overlay
    :show="processing"
    rounded="sm"
    class="product-page"
  >

    <template v-slot:overlay>
      <div
        v-if="processing"
        class="text-center p-4 bg-primary text-light rounded"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-cloud-download"
        ><path
          stroke="none"
          d="M0 0h24v24H0z"
          fill="none"
        /><path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4" /><path d="M12 13l0 9" /><path d="M9 19l3 3l3 -3" /></svg>
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
          min="1"
          max="30"
          :value="counter"
          variant="success"
          height="3px"
          class="mx-n4 rounded-0"
        />
      </div>
    </template>
    <b-card
      title="مدیریت محصول ها"
    >
      <b-row>
        <b-col
          class="table-size"
        >
          <div class="custom-search">
            <b-row>
              <div class="filter-row">
                <div style="width: 100%; display: flex; flex-wrap: wrap;">
                  <b-button
                    class="mb-1 ml-1"
                    variant="primary"
                    :to="{ name: 'addproduct'}"
                  >
                    جدید
                  </b-button>
                  <b-button
                    variant="success"
                    class="mb-1 ml-1"
                    @click="clearCache"
                  >
                    بروزرسانی
                  </b-button>
                  <b-button
                    variant="outline-info"
                    class="mb-1 ml-1"
                    @click="updatePrice"
                  >
                    ویرایش گروهی قیمت
                  </b-button>
                  <b-button
                    variant="outline-info"
                    class="mb-1 ml-1"
                    @click="updateDiscount"
                  >
                    ویرایش گروهی تخفیف
                  </b-button>
                  <b-button
                    variant="outline-info"
                    class="mb-1 ml-1 mr-auto"
                    @click="showImport"
                  >
                    ویرایش گروهی با اکسل
                  </b-button>

                  <b-button
                    variant="outline-warning"
                    class="mb-1 mr-1 ml-1"
                    @click="exportExcel"
                  >
                    خروجی اکسل
                  </b-button>
                </div>
                <div style="width: 100%; display: flex; align-items: flex-end; justify-content: flex-end;">
                  <b-col md="2">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        v-model="filterOptions.Title"
                        @keyup.enter="update(1)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                      label="دسته بندی"
                      label-for="ProductCategoryId"
                    >
                      <product-category
                        v-model="filterOptions.ProductCategoryId"
                        :multiple="false"
                        :clearable="true"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                      label="برند"
                      label-for="BrandId"
                    >
                      <brand
                        v-model="filterOptions.BrandId"
                        :multiple="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>تنوع</label>
                      <v-select
                        v-model="filterOptions.HasVariety"
                        :options="enums('HasVariety')"
                        dir="rtl"
                        label="text"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>وضعیت</label>
                      <v-select
                        v-model="filterOptions.Status"
                        :options="enums('ProductStatus')"
                        dir="rtl"
                        label="text"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    class="mb-1 mr-1"
                    variant="warning"
                    @click="update(1)"
                  >فیلتر
                  </b-button>
                </div>
              </div>
            </b-row>
          </div>

          <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative product-table"
            responsive
            :busy="loading"
            :no-local-sorting="true"
            :sort-by="filterOptions.SortBy"
            :sort-desc="filterOptions.IsDesc"
            @sort-changed="sortChange"
          >
            <template #cell(Id)="data">

              <b-link
                v-if="showSelectInput == false"
                :to="{ name: 'updateproduct', params: { id: data.value }}"
                class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
              <b-form-checkbox
                v-else
                :checked="selectedProducts.includes(data.item.Id)"
                @change="selectProduct($event, data.item.Id)"
              />
            </template>

            <template #cell(Title)="data">
              <div class="align-items-center d-flex">
                <div>
                  <b-avatar
                    class="mr-1"
                    :src="data.item.Image"
                  />
                </div>
                <div>
                  {{ data.value }}
                </div>
              </div>
            </template>

            <template #cell(ProductCategoryDetails)="data">

              <b-badge
                v-for="item in data.value"
                :variant="'light-' + (item.IsMain ? 'primary' : 'info')"
                style="line-height: unset; margin: 2px;"
              >
                {{ item.ProductCategory.Title }}
              </b-badge>
            </template>

            <template #cell(CreatedAt)="data">
              <span class="text-nowrap">
                {{ data.value | date }}
              </span>
            </template>

            <template #cell(Price)="data">
              {{ data.value | price }}
            </template>

            <template #cell(Discount)="data">
              {{ data.value | price }}
            </template>

            <template #cell(Visit)="data">
              {{ data.value | price }}
            </template>

            <template #cell(Status)="data">
              <b-badge
                v-if="data.item.HasVariety"
                variant="primary"
              >
                دارای تنوع
              </b-badge>
              <b-badge
                v-else
                :variant="enums('ProductStatus', 'value', data.value, 'badge')"
              >
                {{ enums('ProductStatus', 'value', data.value, 'text') }}
              </b-badge>
            </template>

            <template #cell(actions)="data">

              <div
                class="action-color"
              >

                <b-link
                  v-show="true"
                  :to="{ name: 'productquestion', query:{ productid: data.item.Id } }"
                >
                  <feather-icon
                    icon="LayoutIcon"
                    size="16"
                  />
                </b-link>

                <b-link
                  v-show="true"
                  :to="{ name: 'productvariety', query:{ productid: data.item.Id } }"
                >
                  <feather-icon
                    icon="PlusSquareIcon"
                    size="16"
                    class="ml-1"
                  />
                </b-link>

                <!--                                            <b-link-->
                <!--                                                    :href="'/product/'+ data.item.Id+ '/'+data.item.Title.replace(' ', '-')"-->
                <!--                                                    target='_blank'-->
                <!--                                            >-->
                <!--                                                <feather-icon-->
                <!--                                                        icon="NavigationIcon"-->
                <!--                                                        size="16"-->
                <!--                                                />-->
                <!--                                            </b-link>-->

                <b-link :to="{ name: 'updateproduct', params: { id: data.item.Id }}">
                  <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                    class="mt-50"
                  />
                </b-link>

                <feather-icon
                  icon="CopyIcon"
                  size="16"
                  class="ml-1 mt-50"
                  @click="duplicate(data.item.Id)"
                />

                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="mt-50"
                  @click="remove(data.item.Id)"
                />

              </div>
            </template>

            <template #table-busy>
              <div
                class="text-center my-2"
              >
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>

            <template #table-busy>
              <div
                class="text-center my-2"
              >
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>

          </b-table>

          <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
          />

        </b-col>

      </b-row>

      <b-modal
        v-if="showPriceModal"
        v-model="showPriceModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="ویرایش گروهی قیمت"
        :no-close-on-backdrop="true"
        size="sm"
        class="bulk-update-modal"
        @ok="savePriceUpdate"
      >

        <b-col
          md="12"
        >
          <b-form-group
            label="نوع"
            label-for="Action"
          >
            <v-select
              v-model="bulkUpdate.Action"
              :options="enums('ProductPriceBulkUpdate')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">

          <b-form-group
            :label="getLabelText()"
            label-for="Amount"
          >
            <b-input-group
              style="direction: ltr;"
              class="input-with-select"
            >
              <b-input-group-prepend
                v-if="bulkUpdate.Action != 0"
                style="    margin-left: 0;
              margin-right: -1px;
              width: 50%; max-width: 100px;"
              >
                <v-select
                  v-model="bulkUpdate.Type"
                  style="width: 100%;"
                  :options="enums('AmountType')"
                  dir="rtl"
                  label="text"
                  :clearable="false"
                  :reduce="x => x.value"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="bulkUpdate.Amount"
                autocomplete="off"
                dir="rtl"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

      </b-modal>

      <b-modal
        v-if="showDiscountModal"
        v-model="showDiscountModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="ویرایش گروهی تخفیف"
        :no-close-on-backdrop="true"
        size="sm"
        class="bulk-update-modal"
        @ok="saveDiscountUpdate"
      >

        <b-col
          md="12"
        >
          <b-form-group
            label="نوع"
            label-for="Action"
          >
            <v-select
              v-model="bulkUpdate.Action"
              :options="enums('ProductDiscountBulkUpdate')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">

          <b-form-group
            :label="getLabelTextDsicount()"
            label-for="Amount"
          >
            <b-form-input
              id="Amount"
              v-model="bulkUpdate.Amount"
              autocomplete="off"
              dir="ltr"
            />
          </b-form-group>
        </b-col>

      </b-modal>

      <b-modal
        v-if="showImportModal"
        v-model="showImportModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="ویرایش گروهی قیمت و تخفیف"
        :no-close-on-backdrop="true"
        size="sm"
        class="bulk-update-modal"
        @ok="saveImport"
      >

        <b-col
          md="12"
        >
          <b-form-group
            label="انتخاب فایل"
            label-for="ImportFile"
          >
            <b-form-file
              v-model="attachment"
              placeholder=""
              :accept="'.xlsx'"
              @change="onFileChange"
            />
          </b-form-group>
        </b-col>

      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'
import Brand from '@/tools/brand.vue'
import axios from '@/libs/axios'

export default {
  name: 'Product',
  components: {
    ProductCategory,
    Brand,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      counter: 1,
      selectedProducts: [],
      importFile: null,
      attachment: null,
      showImportModal: false,
      filterOptions: {
        Title: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        ProductCategoryId: null,
        Status: null,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'ProductCategoryDetails',
          label: 'دسته بندی',
        },
        // {
        //     key: 'Weight',
        //     label: 'وزن',
        // },
        // {
        //     key: 'Wage',
        //     label: 'اجرت',
        // },
        // {
        //     key: 'Profit',
        //     label: 'سود',
        // },
        {
          key: 'Price',
          label: 'قیمت',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'Visit',
          label: 'بازدید',
          sortable: true,
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-89',
        },
      ],
      items: [],
      showPriceModal: false,
      showDiscountModal: false,
      showSelectInput: false,
      bulkUpdate: { Type: 0, Action: 0 },
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.product.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.product.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.product.remove, 'Id', id)
    },
    duplicate(id) {
      this.loading = true
      this.$http.post(
        this.$api.product.duplicate, { Id: id },
      )
        .then(() => {
          this.update()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onRowSelected(items) {
      this.selectedProducts = items
      console.log(this.selectedProducts)
      console.log(items)
    },
    selectProduct(status, id) {
      if (status) {
        this.selectedProducts.push(id)
      } else {
        this.selectedProducts = this.selectedProducts.filter(item => item != id)
      }
    },
    updatePrice() {
      this.bulkUpdate = { Type: 0, Action: 0, Amount: null }
      this.showPriceModal = true
    },
    updateDiscount() {
      this.bulkUpdate = { Type: 0, Action: 0, Amount: null }
      this.showDiscountModal = true
    },
    savePriceUpdate() {
      this.showPriceModal = false
      this.loading = true

      this.$http.post(
        this.$api.product.bulkupdate, this.bulkUpdate,
      )
        .then(res => {
          this.update()
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveDiscountUpdate() {
      this.showDiscountModal = false
      this.loading = true

      this.$http.post(
        this.$api.product.bulkupdatediscount, this.bulkUpdate,
      )
        .then(res => {
          this.update()
        })
        .finally(() => {
          this.loading = false
        })
    },
    getLabelText() {
      if (this.bulkUpdate.Action === 0) {
        return 'قیمت جدید'
      } if (this.bulkUpdate.Action === 1) {
        return 'مقدار افزایش قیمت'
      }
      return 'مقدار کاهش قیمت'
    },
    getLabelTextDsicount() {
      if (this.bulkUpdate.Action === 0) {
        return 'مبلغ تخفیف'
      }
      return 'درصد تخفیف'
    },
    showImport() {
      this.importFile = null
      this.showImportModal = true
    },
    onFileChange(event) {
      this.importFile = event.target.files[0]
    },
    saveImport() {
      const formData = new FormData()
      formData.append('file', this.importFile)

      this.loading = true
      this.$http.post(
        this.$api.product.importexcel, formData,
      )
        .then(() => {
          this.update()
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportExcel() {
      const This = this

      This.counter = 1
      This.processing = true

      const interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      const filename = 'Product.xlsx'
      const xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function () {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
          const remaining = 30 - This.counter

          clearInterval(interval)

          const interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {
            const a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval2)
            This.processing = false
          }, remaining * 100)
        }
      }

      xmlHttpRequest.open('POST', `${axios.defaults.baseURL}product/export-excel`)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    },
  },
}
</script>
<style>
.product-table .badge-light-info,.product-table .badge-light-primary {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.col-width-89{
  width: 89px;
}
.action-color a{
  color: #6e6b7b !important;
}

[dir=rtl] .input-with-select .vs__dropdown-toggle{
  border-radius: 0.357rem 0 0 0.357rem;
}

[dir=rtl] .input-with-select input{
  border-radius: 0 0.357rem 0.357rem 0 !important;
}

</style>
